import { FooterLegalLink } from '../../ads-footer.types';
import { FunctionalComponent, VNode, h } from '@stencil/core';
import { getHyperLinkObject } from '../../../core/interfaces/Hyperlink';

export const AdsFooterLegalLink: FunctionalComponent<FooterLegalLink> = ({ text, title, link }) => {
  const linkObj = getHyperLinkObject(link);
  const anchorAttributes = {
    href: linkObj?.href,
    hrefLang: linkObj?.hreflang || null,
    rel: linkObj?.rel || null,
    target: linkObj?.target || null,
    title: title || null,
    onClick: linkObj?.onClick || null,
    'data-track': 'true',
    'data-track-value': text,
  };

  return (
    <li class="footer-legal-link">
      <a {...anchorAttributes}>{text}</a>
    </li>
  ) as VNode;
};
